import { IconError } from "@icons/index";
import { CommonButton } from "@components/CommonButton";
import classNames from "classnames";
import { Trans } from "react-i18next";

export interface ErrorProps {
  showIcon?: boolean;
  className?: string;
  reload?: () => void;
  traceID?: string;
}

export default ({ className, showIcon = true, reload, traceID }: ErrorProps) => {
  return (
    <div className={classNames("flex flex-col items-center justify-center", className)}>
      {showIcon && <IconError className="icon"></IconError>}
      <div className="error-text">
        <Trans>Something went wrong. Please try again.</Trans>
      </div>
      {traceID && (
        <div className="traceID">
          <Trans>Trace ID</Trans>:{traceID}
        </div>
      )}
      {reload && (
        <CommonButton className="min-w-[90px] h-[36px] mt-[24px]" type="primary" onClick={() => reload()}>
          <Trans>Reload</Trans>
        </CommonButton>
      )}
    </div>
  );
};
